import { render, staticRenderFns } from "./FieldsetButton.vue?vue&type=template&id=4affddb0&"
import script from "./FieldsetButton.vue?vue&type=script&lang=js&"
export * from "./FieldsetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports